import styled from 'styled-components';

export const TableWrapper = styled.div`
	height: 900px;
	width: 900px;
	overflow: scroll;
`;
